'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import MarketActivitySectionLayout from '../MarketActivitySectionLayout';
import { MarketBorrowersLoading } from '../MarketBorrowers';
import { MarketSuppliersLoading } from '../MarketSuppliers';
import { MarketTransactionsLoading } from '../MarketTransactions/states';
const MarketActivitySectionLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MarketActivitySectionLayout allTransactionsSlot={<MarketTransactionsLoading />} borrowersSlot={<MarketBorrowersLoading />} suppliersSlot={<MarketSuppliersLoading />} />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(MarketActivitySectionLoading);